module.exports = __webpack_public_path__ + "static/media/freitas.48a24aae.jpeg";